import { type DefaultOptions, QueryClient } from '@tanstack/react-query';
import { HTTPError } from 'ky';

const MAX_QUERY_RETRIES = 3;

const STALE_TIME_MS = 1000 * 60 * 1; // 1 minute

export const DEFAULT_OPTIONS = {
  queries: {
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry(failureCount, error) {
      if (failureCount > MAX_QUERY_RETRIES) return false;
      if (error instanceof HTTPError && error.response.status === 404) return false;

      return true;
    },
    staleTime: STALE_TIME_MS,
  },
} satisfies DefaultOptions;

export const queryClient = new QueryClient({
  defaultOptions: DEFAULT_OPTIONS,
});
